
import React from "react";
import CounsHero from "../components/counselling/CounsHero";
import CounsellingContent from "../components/counselling/CounsellingContent";



const Counselling = () => {

  return (
    <>
    <CounsHero/>
    <CounsellingContent/>
    </>
  );
};

export default Counselling;
